import {
  api as generatedApi,
  type GetTenantSettingsQuery,
  type UpsertTenantSettingsMutationVariables,
} from './operations.generated';
const api = generatedApi.enhanceEndpoints({
  endpoints: {
    UpsertTenantSettings: {
      async onQueryStarted(
        { input }: UpsertTenantSettingsMutationVariables,
        { dispatch, queryFulfilled },
      ) {
        try {
          await queryFulfilled;
          dispatch(
            generatedApi.util.updateQueryData(
              'GetTenantSettings',
              undefined,
              (draft: GetTenantSettingsQuery) => {
                if (draft?.Tenant?.getSettings) {
                  Object.assign(
                    draft.Tenant.getSettings,
                    input as Partial<typeof draft.Tenant.getSettings>,
                  );
                }
              },
            ),
          );
        } catch {
          // Cache not updated on failure; query can refetch
        }
      },
    },
  },
});

export const {
  useGetTenantSettingsQuery,
  useLazyGetTenantSettingsQuery,
  useUpsertTenantSettingsMutation,
} = api;
